import { render, staticRenderFns } from "./Suggest.vue?vue&type=template&id=4333b808&scoped=true&"
import script from "./Suggest.vue?vue&type=script&lang=js&"
export * from "./Suggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333b808",
  null
  
)

component.options.__file = "Suggest.vue"
export default component.exports